import React from 'react'
import {AiOutlineHome} from "react-icons/ai"

import "../../styles/HomeButton.css"

// Pulsante per il collegamento con il sito dell'Ombrellificio il Parco
export default function HomeButton() {
    return (      
        <a href="https://www.ombrellificioilparco.it" target={"_blank"} rel="noreferrer">
            <button className="homeButton">
                <AiOutlineHome size={"25px"}/>
                HOME
            </button>
        </a>                   
    )
}